module.exports = __webpack_public_path__ + "static/media/logo_white.a5af92f0.png";